module.exports = __webpack_public_path__ + "media/images/logo-footer-530e7bff79cc8e2ec3e7df460d1a19e3.png";